<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <!-- CARD 1: CONGRATS -->
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card
          slot="no-body"
          class="text-center bg-primary-gradient greet-user"
        >
          <img
            src="../assets/images/elements/decore-left.png"
            class="decore-left"
            alt="Decore Left"
            width="200"
          />
          <img
            src="../assets/images/elements/decore-right.png"
            class="decore-right"
            alt="Decore Right"
            width="175"
          />
          <feather-icon
            icon="AwardIcon"
            class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8"
          ></feather-icon>
          <h1 class="mb-6 text-white">欢迎使用Match赛事个人中心！</h1>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
            上次登录时间： {{ lastLoginTime }}
          </p>
          <p class="text-white mt-5">POWER BY JIADA</p>
        </vx-card>
      </div>

      <div class="vx-col w-full lg:w-1/4 md:w-1/2 mb-base">
          <vx-card class="px-6">
              <vs-avatar v-if="!user.photoURL" class="mx-auto my-6 block" size="80px" :src="require('@/assets/images/profile/default-avatar.png')" />
              <vs-avatar v-else class="mx-auto my-6 block" size="80px" :src="user.photoURL"/>
              <div class="text-center">
                  <h4>{{ user.displayName }}</h4>
                  <p class="text-grey">{{ user.motto }}</p>
              </div>
              <div class="flex justify-between text-center">
                  <span>
                      <p class="text-xl font-semibold">{{ statisticsData.matchCount }}</p>
                      <small class="text-grey">参与赛事</small>
                  </span>
                  <span>
                      <p class="text-xl font-semibold">{{ statisticsData.matchSignUpCount }}</p>
                      <small class="text-grey">报名中</small>
                  </span>
                  <span>
                      <p class="text-xl font-semibold">{{ statisticsData.matchingCount }}</p>
                      <small class="text-grey">进行中</small>
                  </span>
                  <!-- <span>
                      <p class="text-xl font-semibold">{{ statisticsData.teamCount }}</p>
                      <small class="text-grey">团队</small>
                  </span> -->
              </div>
          </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/4 md:w-1/2 mb-base">
          <vx-card>
            <div v-if="teamList.length > 0">
              <vs-list class="pb-0 pt-1">
                <vs-list-item class="truncate" :title="item.teamName" :subtitle="item.teamSlogan" :key="index" v-for="(item, index) in teamList">
                  <template slot="avatar">
                    <img class="w-24 h-12" v-if="item.imgSrc" :src="item.imgSrc" alt="team-img">
                    <img class="w-24" v-else :src="require('@/assets/images/team/default_team.png')" alt="team-img">
                  </template>
                </vs-list-item>
              </vs-list>
              <div class="flex justify-between">
                <span class="self-end text-grey">创建的团队：{{ statisticsData.teamCount }}</span>
                <vs-button size="small" iconPack="feather" icon="icon-eye" to="/team/create-list">查看所有</vs-button>
              </div>
              
            </div>
            <p v-else>你还没创建任何团队 ...</p>
          </vx-card>
      </div>

    </div>

    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card title="近期赛事">
          <ul class="activity-timeline">
            <li v-for="(match,index) in latelyMatch" :key="index">
              <div class="timeline-icon" :class="match.status == 3?'bg-success-gradient':'bg-warning-gradient'">
                <feather-icon
                  :icon="match.status == 3?'FlagIcon':'Edit2Icon'"
                  svgClasses="text-white stroke-current w-5 h-5"
                ></feather-icon>
              </div>
              <a :href="match.url" target="_blank" class="timeline-info" :style="{display: 'block', cursor: 'pointer', color: '#626262'}">
                <p class="font-semibold">{{ match.name }} <span class="text-grey">( {{match.status == 3?'进行中':'报名中'}} )</span></p>
                <span class="activity-desc">{{ match.organizer }}</span>
              </a>
              <small class="text-grey activity-e-time">{{ match.startDate }} ~ {{ match.endDate }}</small>
            </li>
          </ul>
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card title="参赛动态">
          <ul class="activity-timeline" v-if="matchDynamic.length > 0">
            <li
              :class="{ 'mt-8': index }"
              v-for="(item, index) in matchDynamic"
              :key="item.id"
            >
              <div class="timeline-icon bg-primary-gradient">
                <span class="relative text-white" :style="{top:'-0.1rem'}">{{ item.create_time.substr(8,2) }}</span>
              </div>
              <div class="flex items-center">
                <div class="leading-tight">
                  <p class="feed-author font-semibold">
                    {{ item.title }}
                  </p>
                </div>
              </div>
              <p class="mt-4">{{ item.content }}</p>
              <small class="mt-3 inline-block">{{
                item.create_time
              }}</small>
            </li>
          </ul>
          <p v-else>没有任何赛事动态</p>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>

import { getToken } from '@/utils/tools';
import { getDynamic } from '@/api/message';
import { list } from "@/api/team";
import { statistics } from '@/api/match';

export default {
  data() {
    return {
      user: {},
      matchDynamic: [],
      teamList: [],
      statisticsData: {
        matchCount: 0,
        teamCount: 0,
        matchingCount: 0,
        matchSignUpCount: 0,
      },
      latelyMatch: [],
    };
  },
  created() {
    this.user = JSON.parse(localStorage.getItem('userInfo'))
    this.getDynamicList()
    this.getCreateList()
    this.getStatistics()
  },
  computed: {
    lastLoginTime() {
      return this.user.lastLoginTime?this.user.lastLoginTime:this.user.registerTime
    }
  },
  components: {
    
  },
  methods: {
    getDynamicList() {
      let that = this
      getDynamic({
        access_token: getToken(),
        type: 1,
        pageNum: 1,
        pageSize: 8
      }).then(res => {
        if (res.data.err_code === 0) {
          that.matchDynamic = res.data.list
        }
      })
    },
    getCreateList() {
      let that = this;
      list({
        access_token: getToken(),
        type: 'create'
      }).then((res) => {
        const data = res.data;
        that.teamList = data.list.slice(0,3);
      });
    },
    getStatistics() {
      statistics({
        access_token: getToken(),
      }).then(res => {
        this.statisticsData = res.data.statistics
        this.latelyMatch = res.data.latelyMatch
      })
    }
  }
}
</script>

<style lang="scss">
#dashboard-analytics {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
